import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { BREAKPOINT_LARGE, BREAKPOINT_SMALL_LARGE, PLOOM_DARK_NAVY } from "@jti/fe-common";
import { useViewport } from "../../hooks/useViewport";
import { replaceStringPlaceholder } from "../../utils/replaceStringPlaceholder/replaceStringPlaceholder";
import { Button } from "../Button";
import { ReferralPersonalCodeBlocks } from "./ReferralPersonalCodeBlocks";
import { ReferralPersonalCodeSmallText } from "./ReferralPersonalCodeSmallText";
import styles from "./ReferralPersonalCode.module.scss";
const { sanitize } = dompurify;
export const ReferralPersonalCode = ({ topHeader, code, header, codeTitle, shareTitle, description, variant = "default", referralPageVariant, items = [], infoTitle, backgroundimage, backgroundimagetablet, backgroundimagemobile, smallText, showCta = false, ctaRow, className, withBottomCta = false, bottomCtaLabel = "", bottomCtaLink = "", }) => {
    const isWithBackgroundImageVariant = variant === "withBackgroundImage";
    const { width } = useViewport();
    const classes = classNames(styles.personalCode, className, {
        [styles.dashboard]: variant === "dashboard",
        [styles.withBackgroundImage]: isWithBackgroundImageVariant,
        [styles.referralPageVariant]: referralPageVariant,
        [styles.showCta]: showCta,
    });
    const replaceUrlCode = (url, code) => {
        return replaceStringPlaceholder(url, [
            {
                placeholder: "referralCode",
                value: code,
            },
        ], false);
    };
    const itemsUrlCodeConverted = useMemo(() => {
        if (items.length === 0 || !code)
            return [];
        return items.map((element) => ({
            ...element,
            url: replaceUrlCode(element.url, code),
        }));
    }, [items, code]);
    const setBackground = () => {
        const isTablet = BREAKPOINT_SMALL_LARGE <= width && width <= BREAKPOINT_LARGE;
        const isBigScreen = width > BREAKPOINT_LARGE;
        if (isBigScreen) {
            return { backgroundImage: `url(${backgroundimage}` };
        }
        if (isTablet) {
            return { backgroundImage: `url(${backgroundimagetablet ? backgroundimagetablet : backgroundimage}` };
        }
        return referralPageVariant
            ? { backgroundColor: PLOOM_DARK_NAVY }
            : { backgroundImage: `url(${backgroundimagemobile})` };
    };
    const backgroundCss = isWithBackgroundImageVariant ? setBackground() : {};
    return (_jsxs(_Fragment, { children: [topHeader && (_jsx("div", { className: styles.topHeader, "data-testid": "referral-personal-code__topHeader", children: topHeader })), _jsxs("div", { className: classes, style: backgroundCss, "data-testid": "referral-personal-code", children: [isWithBackgroundImageVariant && (_jsxs(_Fragment, { children: [referralPageVariant && _jsx("img", { className: styles.mobileImg, src: backgroundimagemobile, alt: "" }), _jsx("div", { className: styles.header, children: header })] })), _jsx("div", { className: styles.title, "data-testid": "your-personal-code-header", children: codeTitle }), description && (_jsx("div", { className: styles.description, dangerouslySetInnerHTML: {
                            __html: sanitize(description),
                        } })), showCta && ctaRow ? (ctaRow) : (_jsx(ReferralPersonalCodeBlocks, { code: code, items: itemsUrlCodeConverted, infoTitle: infoTitle, shareTitle: shareTitle })), _jsx(ReferralPersonalCodeSmallText, { smallText: smallText, isWithBackgroundImageVariant: isWithBackgroundImageVariant }), withBottomCta && (_jsx("div", { className: styles.bottomCta, children: _jsx(Button, { color: "tertiary", type: "cta", href: bottomCtaLink, children: bottomCtaLabel }) }))] })] }));
};
//# sourceMappingURL=ReferralPersonalCode.js.map